<template>
    <section>
        <SectionHeading :title="'Invite people to ' + account.name" importance="2" />
        <form @submit.prevent="sendPersonalInvite">
            <div class="space-y-8">
                <div class="grid grid-cols-4 gap-x-6">
                    <div class="">
                        <label for="email" class="block font-medium text-gray-800 sm:mt-px sm:pt-2">
                            Email
                        </label>
                    </div>
                    <div class="col-span-3">
                        <div class="relative flex space-x-2">
                            <input type="email" name="email" v-model="form.email" class="rounded-lg w-full" required>
                        </div>
                        <InlineError v-if="form.errors.email" :message="form.errors.email"/>
                    </div>
                </div>
                <div class="grid grid-cols-2 gap-x-6 items-center">
                    <div class="">
                        <div class="">
                            <div class="flex items-center" :class="{ 'space-x-3': url}">
                                <div @click="copy" v-if="!processing">
                                    <div v-if="showTooltip" class="">
                                        <div class="relative w-full flex items-center justify-center">
                                            <div class="flex space-x-1 -translate-y-1/2 mb-2 items-center text-white absolute w-screen max-w-[8rem] bg-regal-blue-900 rounded-md p-3 text-sm font-medium">
                                                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
                                                <div class="">
                                                    Link copied
                                                </div>
                                            </div>
                                            <div class="absolute -bottom-0.5 w-full flex items-center justify-center">
                                                <div class="w-3 h-3 bg-regal-blue-900 rotate-45 rounded-xs">

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="url">
                                        <Button label="Copy invite link" type="secondary" icon="ClipboardCopyIcon" />
                                    </div>
                                </div>
                                <div @click="getInviteUrl" v-if="!processing && !url">
                                    <div>
                                        <Button label="Create invite link" type="secondary" icon="LinkIcon" />
                                    </div>
                                </div>
                                <input type="text" name="" value="" class="hidden" ref="copyUrl">
                                <div v-if="token" @click="$emit('editLink', token)" class="text-regal-blue-700 hover:text-regal-blue-800 hover:underline cursor-pointer">Edit link settings</div>
                                <div v-if="processing">
                                    <div>
                                        <Button label="Working" type="busy" />
                                    </div>
                                </div>
                                <!-- <div v-if="url">
                                    <input type="url" v-model="url" disabled class="rounded-lg w-full">
                                </div> -->
                            </div>
                            <!-- <div v-if="sharedInvite">
                                <div>Copy invite link <Link :href="'/invites/' + sharedInvite.token + '/edit'">| Edit link settings</Link></div>
                            </div> -->
                        </div>
                    </div>
                    <div class="text-right">
                        <button type="submit">
                            <Button label="Send" />
                        </button>
                    </div>
                </div>
            </div>
        </form>


    </section>

</template>

<script>
    import Layout from '@/Shared/Layout'
    import { useForm } from '@inertiajs/inertia-vue3'
    import axios from 'axios'
    import { computed, defineComponent } from 'vue'
    import InlineError from '@/Shared/InlineError'
    import Button from '@/Shared/Button'
    import SectionHeading from '@/Shared/SectionHeading'
    import { usePage } from '@inertiajs/inertia-vue3'
    import { ref } from 'vue'

    export default {
        setup (props) {
            const account = computed(() => usePage().props.value.auth.account)
            const processing = ref(false)
            const url = ref(null)
            const token = props.sharedInvite ? props.sharedInvite.token : ref(null)
            const showTooltip = ref(false)

            const form = useForm({
                email: null,
                type: 'personal',
            })


            return { form, account, processing, url, token, showTooltip }
        },
        components: { InlineError, Button, SectionHeading },
        props: {
            'sharedInvite': Object,
            'open': Boolean,
        },
        emits: [ 'editLink', 'update:open' ],
        layout: Layout,
        mounted() {
            if (this.sharedInvite) {
                this.url = this.sharedInvite.url
            }
        },
        methods: {
            sendPersonalInvite() {
                this.form.post('/invites', {
                    onSuccess: (page) => {
                        this.form.reset()
                        this.$emit('update:open', false)
                    },
                })
            },
            getInviteUrl() {
                this.processing = true
                axios.post('/invites', {
                        'type': 'shared',
                    })
                    .then((response) => {
                        this.url = response.data.inviteUrl
                        this.token = response.data.token
                        this.processing = false
                        // this.copy(this.url)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            async copy() {
                try {
                    await navigator.clipboard.writeText(this.url).then(fn => {
                        this.showTooltip = true
                        setTimeout(() => {this.showTooltip = false}, 1500);
                    });
                } catch(e) {
                    console.log(e);
                }
            }
        },
    }
</script>
